export default "__VITE_ASSET__609bbdc0__"